module.exports = require('react')
